export default "__VITE_ASSET__257c42df__"